import { render, staticRenderFns } from "./TermsAndConditions1.vue?vue&type=template&id=61232794&scoped=true"
import script from "./TermsAndConditions1.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61232794",
  null
  
)

export default component.exports